import { FiFileText } from "react-icons/fi";
import previewImg from "../../assets/img/kebijakan-keamanan-informasi.webp";

export default function Content() {
    return (
        <div className="max-w-screen-2xl mx-auto pt-16 pb-60 px-5 lg:px-20 space-y-10">

            <div className="bg-gradient-to-br from-[#00274D] to-[#001C36] border border-[#0081FF]/30 rounded-2xl overflow-hidden shadow-lg">
                <div className="bg-gradient-to-r from-[#0081FF]/20 to-[#00B3FF]/20 border-b border-[#0081FF]/30 p-4 flex items-center">
                    <h3 className="text-lg font-bold text-white flex items-center">
                        <FiFileText className="w-5 h-5 mr-2 text-[#FFC107]" />
                        Dokumen Kebijakan Keamanan Informasi
                    </h3>
                </div>

                <div className="bg-[#001C36] p-6 flex justify-center">
                    <img
                        src={previewImg}
                        alt="Preview Kebijakan Keamanan Informasi"
                        className="rounded-xl border border-[#0081FF]/30 shadow-lg w-full max-w-3xl object-contain hover:scale-[1.02] transition-transform duration-300"
                    />
                </div>
            </div>

            <div className="bg-gradient-to-br from-[#00274D] to-[#001C36] border border-[#0081FF]/30 backdrop-blur-lg rounded-2xl p-8 shadow-xl">
                <h3 className="text-2xl font-bold text-[#FFC107] mb-6">
                    Ringkasan Dokumen
                </h3>

                <div className="space-y-4 text-[#E0F2FF]">
                    <p className="leading-relaxed">
                        <strong>BPR PALU ANUGERAH</strong> berkomitmen menerapkan
                        <strong> Sistem Manajemen Keamanan Informasi (SMKI)</strong>
                        berdasarkan standar internasional <strong>ISO/IEC 27001:2022</strong>,
                        serta mematuhi peraturan yang berlaku dalam menjaga keamanan
                        informasi dan data perusahaan.
                    </p>

                    <div className="bg-[#0081FF]/10 border border-[#0081FF]/30 rounded-xl p-6 space-y-3">
                        <h4 className="font-bold text-[#FFC107] text-lg">Komitmen Utama:</h4>
                        <ul className="space-y-2 pl-4">
                            <li className="flex items-start">
                                <span className="text-[#00B3FF] mr-3">•</span>
                                <span>
                                    Menjamin <strong>kerahasiaan, integritas,</strong> dan
                                    <strong> ketersediaan informasi</strong> dengan kontrol
                                    sesuai <strong>ISO 27001:2022</strong>.
                                </span>
                            </li>
                            <li className="flex items-start">
                                <span className="text-[#00B3FF] mr-3">•</span>
                                <span>
                                    Melindungi <strong>data dan dokumen</strong> dari akses,
                                    perubahan, atau pengungkapan yang tidak sah.
                                </span>
                            </li>
                            <li className="flex items-start">
                                <span className="text-[#00B3FF] mr-3">•</span>
                                <span>
                                    Menyediakan <strong>pengamanan administratif, teknis, dan fisik</strong>
                                    untuk melindungi data pribadi dan aset informasi.
                                </span>
                            </li>
                        </ul>
                    </div>

                    <p className="leading-relaxed">
                        Melalui kebijakan ini, <strong>BPR PALU ANUGERAH</strong> menegaskan
                        komitmennya dalam menjaga kepercayaan nasabah melalui tata kelola
                        keamanan informasi yang berkelanjutan dan sesuai praktik terbaik industri.
                    </p>
                </div>
            </div>
        </div>
    );
}
